import { render, staticRenderFns } from "./Timeslots.vue?vue&type=template&id=871fe77c&scoped=true"
import script from "./Timeslots.vue?vue&type=script&lang=js"
export * from "./Timeslots.vue?vue&type=script&lang=js"
import style0 from "./Timeslots.vue?vue&type=style&index=0&id=871fe77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fe77c",
  null
  
)

export default component.exports